import { trackStep, sessionId } from './attribution';
import { isInternalDevice } from './landing';

// Route du Worker (netlify-proxy/worker.js), même origine que la page.
const API_TRACK = '/api/analytics/event';

const getBaseMeta = () => ({
  referrer: document.referrer || '',
  screen: `${window.screen.width}x${window.screen.height}`,
  language: navigator.language || '',
  url: window.location.href,
});

export const trackPageView = (page) => {
  fetch(API_TRACK, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event: 'page_view', page, metadata: getBaseMeta() }),
  }).catch(() => {});
};

export const trackCheckoutStart = (buttonId) => {
  trackStep('cta', { button: buttonId });
  fetch(API_TRACK, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      type: 'join',
      event: 'checkout_start',
      page: window.location.pathname,
      button: buttonId,
      sid: sessionId(),
      internal: isInternalDevice() || undefined,
      metadata: { ...getBaseMeta(), button: buttonId },
    }),
  }).catch(() => {});
};

export const trackButtonClick = (buttonId) => {
  fetch(API_TRACK, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event: 'button_click',
      page: window.location.pathname,
      metadata: { ...getBaseMeta(), button: buttonId },
    }),
  }).catch(() => {});
};
